import { Separator } from "@/components/ui/separator"; // Asumiendo la ruta de importación
import type React from "react";

interface HeaderSectionProps {
    title: string;
    description: string;
}

const HeaderSection: React.FC<HeaderSectionProps> = ({
    title,
    description,
}) => {
    return (
        <>
            <div className="space-y-1">
                <h3 className="text-xl font-semibold tracking-tight lg:text-2xl">
                    {title}
                </h3>
                <p className="text-sm leading-relaxed text-muted-foreground">
                    {description}
                </p>
            </div>
            <Separator className="my-4" />
        </>
    );
};

export default HeaderSection;
